export default __webpack_public_path__ + "static/media/firebase.2846ad59.svg";